export default __webpack_public_path__ + "static/media/facebook.a67c8be5.svg";